import { useEffect } from "react"

import { useOrganization, useUser } from "@clerk/nextjs"

import { useAnalytics } from "../useAnalytics"

export function PostHogIdentify() {
  const { user } = useUser()
  const { organization } = useOrganization()
  const { identify } = useAnalytics()

  useEffect(() => {
    if (!user || !organization) {
      return
    }

    identify(user.id, {
      email: user.primaryEmailAddress?.emailAddress,
      name: user.fullName,
      organization: organization.slug,
    })
  }, [user, organization, identify])

  return null
}
